// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"5d43ff45","187":"c0bed1ab","480":"bc1ba241","557":"394d0f5c","632":"1769baaf","787":"1611bd43","806":"1a105707","838":"7ac95bab","850":"c403d6a5","871":"5909e3eb"}[chunkId] + ".chunk.js";
};